﻿import {GameScreen, UIState} from "../enums";
import {Core} from "./Core";
import {UIBase} from "../UI/Tools/Base/UIBase";
import {UIAdsEvolve} from "../UI/Panels/UIAdsEvolve";
import {UIBank} from "../UI/Panels/UIBank";
import {UIChestOpen} from "../UI/Panels/UIChestOpen";
import {UIChestReward} from "../UI/Panels/UIChestReward";
import {UICoinsBooster} from "../UI/Panels/UICoinsBooster";
import {UICollection} from "../UI/Panels/UICollection";
import {UICreatures} from "../UI/Panels/UICreatures";
import {UIFirstCreatureOffer} from "../UI/Panels/UIFirstCreatureOffer";
import {UIGame} from "../UI/Panels/UIGame";
import {UIGDPR} from "../UI/Panels/UIGDPR";
import {UIInterstitialRewardRandom} from "../UI/Panels/UIInterstitialRewardRandom";
import {UILoader} from "../UI/Panels/UILoader";
import {UIMap} from "../UI/Panels/UIMap";
import {UIMissionActive} from "../UI/Panels/UIMissionActive";
import {UIMissionEmpty} from "../UI/Panels/UIMissionEmpty";
import {UIMissionRewards} from "../UI/Panels/UIMissionRewards";
import {UIMissionsList} from "../UI/Panels/UIMissionsList";
import {UIMoneyBox} from "../UI/Panels/UIMoneyBox";
import {UIMoneyButtons} from "../UI/Panels/UIMoneyButtons";
import {UINewCreature} from "../UI/Panels/UINewCreature";
import {UINewEpoch} from "../UI/Panels/UINewEpoch";
import {UINextEpochChoose} from "../UI/Panels/UINextEpochChoose";
import {UINoSpace} from "../UI/Panels/UINoSpace";
import {UINotEnoughMoney} from "../UI/Panels/UINotEnoughMoney";
import {UIOneTimeOfferConfirm} from "../UI/Panels/UIOneTimeOfferConfirm";
import {UIQuit} from "../UI/Panels/UIQuit";
import {UIReset} from "../UI/Panels/UIReset";
import {UISettings} from "../UI/Panels/UISettings";
import {UISkipEpochsOffer} from "../UI/Panels/UISkipEpochsOffer";
import {UISlots} from "../UI/Panels/UISlots";
import {UISpinsOffer} from "../UI/Panels/UISpinsOffer";
import {UIStarterPackPopup} from "../UI/Panels/UIStarterPackPopup";
import {UITapChallenge} from "../UI/Panels/UITapChallenge";
import {UITapChallengeLost} from "../UI/Panels/UITapChallengeLost";
import {UIUpgrades} from "../UI/Panels/UIUpgrades";
import {UIVip} from "../UI/Panels/UIVip";
import {UIVipDailyReward} from "../UI/Panels/UIVipDailyReward";
import {LastMonsterAnimation} from "../UI/LastMonsterAnimation";
import {TutorialPanel} from "../UI/TutorialPanel";
import {Queue} from "../Utils/Unity/Queue";
import {UITapChallengeVictory} from "../UI/Panels/UITapChallengeVictory";
import {Time} from "../Utils/Unity/Time";
import {UIText} from "../UI/Tools/Base/UIText";
import {PausePopup} from "../UI/PausePopup";

export class UICore extends UIBase {

    get IsSomethingFullScreenOpened() {
        return this.slots.Active || this.map.Active;
    }

    Awake() {
        this.Initialized = false;

        this.loader = new UILoader();
        this.game = new UIGame();
        this.bank = new UIBank();
        this.settings = new UISettings();
        this.moneyButtons = new UIMoneyButtons();
        this.tapChallenge = new UITapChallenge();
        this.tapChallengeVictory = new UITapChallengeVictory();
        this.tapChallengeLost = new UITapChallengeLost();
        this.moneyBox = new UIMoneyBox();
        this.creatures = new UICreatures();
        this.upgrades = new UIUpgrades();
        this.map = new UIMap();
        this.collection = new UICollection();
        this.nextEpochSelection = new UINextEpochChoose();
        this.notEnoughHardMoney = new UINotEnoughMoney();
        this.starterPackPopup = new UIStarterPackPopup();
        this.newCreature = new UINewCreature();
        this.missionEmpty = new UIMissionEmpty();
        this.missionActive = new UIMissionActive();
        this.missionRewards = new UIMissionRewards();
        this.missionsList = new UIMissionsList();
        this.newEpoch = new UINewEpoch();
        this.tutorial = new TutorialPanel();
        this.noSpace = new UINoSpace();
        this.vip = new UIVip();
        this.vipDailyReward = new UIVipDailyReward();
        this.lastMonsterAnimation = new LastMonsterAnimation();
        this.coinsBooster = new UICoinsBooster();
        this.gdpr = new UIGDPR();
        this.adsEvolve = new UIAdsEvolve();
        this.chestOpen = new UIChestOpen();
        this.chestReward = new UIChestReward();
        this.quit = new UIQuit();
        this.reset = new UIReset();
        this.slots = new UISlots();
        this.interstitialRewardRandom = new UIInterstitialRewardRandom();
        this.skipEpochsOffer = new UISkipEpochsOffer();
        this.firstCreatureOffer = new UIFirstCreatureOffer();
        this.spinsOffer = new UISpinsOffer();
        this.confirmOneTimeOffer = new UIOneTimeOfferConfirm();
        this.pausePopup = new PausePopup();
        this.allUI = []; // List<UIBase>
        this.backUIs = []; // List<UIBase>
        this.showOrder = new Queue(); // Queue<Action>
        this.state = UIState[0]; // UIState
        this.timeWithoutPopups = 0; // float

        this.vfxLayer = new PIXI.Container();

        window.addEventListener("keydown", e => {
            switch (e.key) {
                case "Escape":
                    return this.backAction();
            }
        });

        this.__testText = this.addChild(new UIText("", {fill: 0xFF0000, stroke: 0xFFFF00, strokeWidth: 2, fontSize: 26}));
    }

    __debug(str = "") {
        this.__testText.text = str || "";
    }

    Init() {
        this.allUI = [
            this.loader,
            this.lastMonsterAnimation,
            this.map,
            this.game,
            this.slots,
            this.moneyButtons,
            this.tapChallenge,
            this.creatures,
            this.upgrades,
            this.bank,
            this.tapChallengeVictory,
            this.tapChallengeLost,
            this.collection,
            this.settings,
            this.reset,
            this.nextEpochSelection,
            this.moneyBox,
            this.notEnoughHardMoney,
            this.starterPackPopup,
            this.newCreature,
            this.missionEmpty,
            this.missionActive,
            this.missionRewards,
            this.missionsList,
            this.newEpoch,
            this.tutorial,
            this.noSpace,
            this.vip,
            this.vipDailyReward,
            this.gdpr,
            this.coinsBooster,
            this.adsEvolve,
            this.chestOpen,
            this.chestReward,
            this.quit,
            this.interstitialRewardRandom,
            this.firstCreatureOffer,
            this.skipEpochsOffer,
            this.spinsOffer,
            this.confirmOneTimeOffer,
            this.pausePopup,
        ];

        for (let ui of this.allUI) {
            ui.Active = false;
            if (ui.Init) ui.Init();
            this.addChild(ui);
        }

        let vfxZIndex = this.children.indexOf(this.tapChallenge) + 1;
        this.addChildAt(this.vfxLayer, vfxZIndex);

        this.backUIs = [];//new List<UIBase>();
        for (let ui of this.allUI) {
            if (ui.HideWithBackButton) {
                this.backUIs.push(ui);
            }
        }

        this.Initialized = true;
    }

    fitLayout(viewport) {

        this.moneyButtons.fitLayout(viewport);
        this.map.fitLayout(viewport);
        this.newCreature.fitLayout(viewport);
        this.nextEpochSelection.fitLayout(viewport);
        this.game.fitLayout(viewport);
        this.tutorial.fitLayout(viewport);

        this.__testText.position.set(viewport.width * 0.5, viewport.height * 0.5);
    }

    GetGameScreen() {
        switch (this.state) {
            case UIState.BankHard:
            case UIState.BankSoft:
            case UIState.Boosters:
                return GameScreen.boosters;

            case UIState.Map:
                return GameScreen.map;
        }

        if (this.creatures.Active) return GameScreen.monsters;
        if (this.collection.Active) return GameScreen.collection;
        if (this.missionActive.Active || this.missionsList.Active || this.missionRewards.Active) {
            return GameScreen.missions;
        }
        return GameScreen.empty;
    }

    IsSomethingShowing() {
        return (
            this.slots.Active ||
            this.noSpace.Active ||
            this.newCreature.Active ||
            this.newEpoch.Active ||
            this.bank.Active ||
            this.creatures.Active ||
            this.upgrades.Active ||
            this.map.Active ||
            this.collection.Active ||
            this.settings.Active ||
            this.moneyBox.Active ||
            this.gdpr.Active ||
            this.vip.Active ||
            this.vipDailyReward.Active ||
            this.loader.Active ||
            this.coinsBooster.Active ||
            this.nextEpochSelection.Active ||
            this.adsEvolve.Active ||
            this.chestOpen.Active ||
            this.chestReward.Active ||
            this.quit.Active ||
            this.interstitialRewardRandom.Active ||
            this.firstCreatureOffer.Active ||
            this.skipEpochsOffer.Active ||
            this.tapChallengeLost.Active ||
            this.tapChallengeVictory.Active ||
            this.spinsOffer.Active ||
            this.pausePopup.Active ||
            Core.Ads.showing
        );
    }

    // UIState state
    SetState(state) {
        this.state = state;
        this.updateUI();
        this.emit("StateChanged", this.state);
    }

    updateUI() {
        this.loader.SetActive(this.state == UIState.Loading);
        let isBank = this.state == UIState.BankHard || this.state == UIState.BankSoft || this.state == UIState.Boosters;
        this.game.SetActive(this.state == UIState.Game || isBank);
        this.moneyButtons.SetActive(this.state == UIState.Game || isBank || this.state == UIState.Map);
        this.bank.SetActive(isBank);
        this.map.SetActive(this.state == UIState.Map);
    }

    Update() {
        if (!this.Initialized) return;

        for (let ui of this.allUI) {
            if (ui.Active) {
                ui.Update();
            }
        }

        if (this.showOrder.length > 0) {
            if (!this.IsSomethingShowing()) {
                this.timeWithoutPopups += Time.deltaTime;
            } else {
                this.timeWithoutPopups = 0;
            }
            if (this.timeWithoutPopups >= 0.75) {
                let action = this.showOrder.Dequeue();
                if (action) {
                    action();
                }
            }
        }
    }

    backAction() {
        if (!this.backUIs) return;
        if (!Core.UI) return;

        for (let p of this.backUIs) {
            if (!p) continue;
            if (p.Active) {
                if (p instanceof UIMap) {
                    Core.UI.SetState(UIState.Game);
                } else if (p instanceof UIBank) {
                    Core.UI.SetState(UIState.Game);
                } else if (p instanceof UIMoneyBox) {
                    Core.UI.moneyBox.onClickTake();
                } else if (p instanceof UISlots) {
                    Core.UI.slots.onClickClose();
                } else {
                    p.Hide();
                }

                return;
            }
        }

        Core.UI.quit.Show();
    }

    ShowOrder(callback) {
        this.timeWithoutPopups = 0;
        this.showOrder.Enqueue(callback);
    }
}
